import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { ConfigurationPage } from "../components/ConfigurationPage";
import { Filters } from "./components/filters";
import { FormsTable } from "./components/formsTable/formsTable";
import { useSearchForms } from "./hooks/useSearchForms";

type Props = {};

export const ConfigurationFormsPage = (prop: Props) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const searchForms = useSearchForms({ setIsLoading, setError });

	useEffect(() => {
		searchForms();
	}, []);

	return (
		<ConfigurationPage
			title="Forms"
			filters={<Filters searchForms={searchForms} />}
		>
			<Paper
				elevation={1}
				style={{
					width: "100%",
					padding: "10px 0 20px",
					borderRadius: "0.75rem",
				}}
			>
				<FormsTable
					isLoading={isLoading}
					searchForms={searchForms}
					error={error}
					setError={setError}
				/>
			</Paper>
		</ConfigurationPage>
	);
};
